//
// Copyright (c) 2011-2018 by Curalate, Inc.
//

import { Opaque } from '@utils/opaque';

/**
 * Our old-school Fanreel identifiers.
 *
 * Today, these represent a moderation queue of content.
 * They are also used as the metrics ID for experiences.
 */
type ReelId = Opaque<string, 'ReelId'>;

function ReelIdFactory(reelId: string) {
  return reelId as ReelId;
}

const ReelId = ReelIdFactory;

export default ReelId;
